const ID = {
    secondaryCloseBtn: 'fb-survey-secondary-close-btn',
}

const CLASSES = {
    primaryCloseBtn: "ui-dialog-titlebar-close"
}

const listenForSecondaryCloseBtnClick = () => {
    document.addEventListener('click', () => {
        setTimeout(() => {
            const primaryCloseBtn = document?.querySelector('.' + CLASSES.primaryCloseBtn);
            const secondaryCloseBtn = document?.getElementById(ID.secondaryCloseBtn);
            if (secondaryCloseBtn != null && primaryCloseBtn != null) {
                secondaryCloseBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    primaryCloseBtn.click();
                })                
            }
          }, 1000);
    });
}

export default {
    listenForSecondaryCloseBtnClick
}